module.exports = __webpack_public_path__ + "e79397496b91662e4735ac3675baa9cf.png";